import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import Form from "../../../components/commonComponent/Form";
import Loader from "../../../components/commonComponent/Loader";
import { MODE } from "../../../constants/SiteConstants";

const API_URL = process.env.REACT_APP_API_URL;

const fields = [
  {
    label: "Name",
    name: "fullName",
    placeholder: "Enter your name",
    required: true,
  },
  {
    label: "Email",
    name: "email",
    placeholder: "Enter email",
    type: "email",
    required: true,
  },
  {
    label: "Password",
    name: "password",
    placeholder: "Enter Password",
    required: true,
  },
  {
    label: "Address",
    name: "address",
    placeholder: "Enter address",
    required: true,
  },
  {
    label: "Phone Number",
    name: "phoneNumber",
    placeholder: "Enter phone number",
    required: true,
  },
];

const EditUser = () => {
  const { id } = useParams();
  const [initialData, setInitialData] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (id) {
      const loadUserData = async () => {
        try {
          const response = await axios.get(
            `${API_URL}/users/getUserById/${id}`
          );
          setInitialData(response.data.data);
        } catch (error) {}
      };
      loadUserData();
    }
  }, [id]);

  const handleSubmit = async (formData) => {
    try {
      await axios.put(`${API_URL}/users/updateUserById/${id}`, formData);
      toast.success("Data updated successfully", {
        autoClose: 1000,
      });
      navigate("/userManagement");
    } catch (error) {
      toast.error("Error updating data", {
        autoClose: 1000,
      });
    }
  };

  return (
    <div className="form-wrapper shadow-md">
      <div className="form-header">
        <h3 className="font-medium text-black border-b border-gray-300 pb-2 w-full">
          Update User
        </h3>
        <button
          className="form-close-btn"
          onClick={() => navigate("/userManagement")}
        >
          &times;
        </button>
      </div>
      {initialData ? (
        <Form
          mode={MODE.UPDATE}
          onSubmit={handleSubmit}
          fields={fields}
          initialData={initialData}
        />
      ) : (
        <Loader />
      )}
    </div>
  );
};

export default EditUser;
